export const cookiesPolicy   = [
    {
      title : {pt:'Política de cookies', en: "Cookies Policy", es: 'Politica de Cookies', fr: "Politique de cookies",it: "Politica sui cookie",zhCN: "Cookie 政策"},
      text: { 
        pt: `
        <2>Política de cookies?</2>       
        <p>A Advance Lighting utiliza, nos seus Websites, cookies que permitem melhorar o desempenho e a experiência de navegação dos nossos utilizadores, aumentando, por um lado, a rapidez e eficiência de resposta e, por outro, eliminando a 
        necessidade de introduzir repetidamente as mesmas informações. Ao aceitares a Política de Cookies da Advance Lighting&nbsp;deverás ter em consideração que a utilização de cookies possibilita a personalização da utilização e a apresentação 
        de serviços e ofertas adaptadas aos seus interesses. Podes alterar as tuas definições de cookies a qualquer altura.</p>
        <2>O que são cookies?</2>
        <p>Os cookies são pequenos ficheiros de texto enviados para o teu computador ou dispositivo móvel quando visitas websites. Os cookies ajudam os websites a armazenar e recuperar informação sobre os teus hábitos de navegação por forma a personalizar 
        a navegação de acordo com as tuas preferências.</p>
        <p>Os cookies podem ser categorizados face ao propósito que servem. Existem cookies que são estritamente necessários ao funcionamento dos <4>websites</4>, enquanto outros recolhem informação estatística com o intuito de analisar a utilização 
        dos <4>websites</4> e respetivo desempenho; ou para assegurar a disponibilização de funcionalidades adicionais aos <4>websites;</4> ou até para guardar as preferências do visitante relativamente à navegação nos mesmos. Outros cookies 
        podem ainda servir para medir o sucesso de aplicações e a eficácia da publicidade de terceiros.</p>
        <2>Como posso gerir as cookies?</2>
        <p>Com exceção dos cookies estritamente necessários ao desempenho dos <4>websites</4>, o armazenamento de outros cookies dependerá sempre da aceitação e consentimento do utilizador.</p>
        <p>Podes alterar as tuas definições de cookies a qualquer altura na ferramenta de gestão de preferências de cookies disponível nos Websites da Advance Lighting.</p>
        <2>Transferência de dados para países terceiros à União Europeia</2>
        <p>A utilização de determinados Cookies poderá implicar a transferência de dados pessoais para um país terceiro à União Europeia. A Advance Lighting&nbsp;garante que verifica o grau de maturidade do país de destino e adota as garantias adequadas, 
        contratuais ou de outra natureza, para mitigar os riscos de cada transferência de dados pessoais. Nomeadamente, as transferências de dados pessoais para países terceiros à União Europeia ocorrerão para países que beneficiam de uma decisão de
         adequação da Comissão Europeia ou se estiverem implementadas as Cláusulas Contratuais-Tipo aprovadas pela Comissão Europeia.</p>
        <p>Poderás verificar, nos quadros seguintes, onde se localizam cada um dos cookies que utilizamos.&nbsp;</p>`,

        en: `   
         <2>Cookies Policy?</2>       
        <p>Advance Lighting uses cookies on its websites to improve the performance and browsing experience of our users, increasing, on the one hand, speed and efficiency of response and, on the other, eliminating the need to repeatedly enter the same information. 
        and efficiency of response and, on the other hand, eliminating the need to repeatedly enter the same information. By accepting Advance Lighting's Cookie Policy&nbsp;you must 
        take into account that the use of cookies makes it possible to personalize use and present services and offers tailored to your interests. You can change your cookie settings at any time.</p>
        <2>What are cookies?</2>
        <p>Cookies are small text files sent to your computer or mobile device when you visit websites. Cookies help websites store and retrieve 
        information about your browsing habits in order to personalize browsing according to your preferences.</p>
        <p>Cookies can be categorized according to the purpose they serve. There are cookies that are strictly necessary for the functioning of <4>websites</4>, while others collect 
        statistical information with the aim of analyzing the use of <4>websites</4> and their performance; or to ensure the provision of additional functionalities to 
        <4>websites;</4> or even to save the visitor's preferences regarding browsing there. Other cookies may also be used to measure the success of applications and the effectiveness of third-party advertising.</p>
        <2>How can I manage cookies?</2>
        <p>With the exception of cookies strictly necessary for the performance of the <4>websites</4>, the storage of other cookies will always depend on the user's acceptance and consent.</p>
        <p>You can change your cookie settings at any time in the cookie preference management tool available on Advance Lighting Websites.</p>
        <2>Data transfer to countries outside the European Union</2>
        <p>The use of certain Cookies may involve the transfer of personal data to a country outside the European Union. Advance Lighting ensures that it verifies the degree of maturity 
        of the destination country and adopts appropriate guarantees, contractual or otherwise, to mitigate the risks of each transfer of personal data. Namely, transfers of personal data 
        for countries third to the European Union will occur for countries that benefit from an adequacy decision by the European Commission or if the Standard Contractual Clauses approved by the European Commission are implemented.</p>
        <p>You can see, in the following tables, where each of the cookies we use are located..&nbsp;</p>`,
        es: `
        <2>Politica de Cookies?</2>           
        <p>Advance Lighting utiliza, en sus Sitios Web, cookies que nos permiten mejorar el rendimiento y experiencia de navegación de nuestros usuarios, aumentando, por un lado, la rapidez y eficacia de respuesta y, por otro, eliminando la 
        Es necesario ingresar repetidamente la misma información. Al aceptar la Política de Cookies de Advance Lighting debe tener en cuenta que el uso de cookies permite la personalización de uso y presentación 
        de servicios y ofertas adaptadas a sus intereses. Puede cambiar la configuración de cookies en cualquier momento.</p>
        <2>Que son cookies?</2>
        <p> Las cookies son pequeños archivos de texto que se envían a su computadora o dispositivo móvil cuando visita sitios web. Las cookies ayudan a los sitios web a almacenar y recuperar información sobre sus hábitos de navegación para personalizar 
        Navegación según tus preferencias.</p>

        <p>Las cookies se pueden clasificar según la finalidad para la que sirven. Hay cookies estrictamente necesarias para el funcionamiento de los <4>sitios web</4>, mientras que otras recogen información estadística con la finalidad de analizar su uso. 
        <4>sitios web</4> y su rendimiento; o para asegurar la dotación de funcionalidades adicionales a los <4>sitios web;</4> o incluso para guardar las preferencias del visitante respecto a la navegación en los mismos. Otras galletas 
        También se pueden utilizar para medir el éxito de las aplicaciones y la eficacia de la publicidad de terceros.</p>

        <2>¿Cómo puedo gestionar las cookies?</2>
        <p>A excepción de las cookies estrictamente necesarias para el funcionamiento de los <4>sitios web</4>, el almacenamiento de otras cookies dependerá siempre de la aceptación y consentimiento del usuario.</p>
        <p>Puede cambiar la configuración de cookies en cualquier momento en la herramienta de gestión de preferencias de cookies disponible en los sitios web de Advance Lighting.</p>
        <2>Transferencia de datos a países fuera de la Unión Europea</2>
        <p>El uso de determinadas Cookies puede implicar la transferencia de datos personales a un país fuera de la Unión Europea. Advance Lighting garantiza que verifica el grado de madurez del país de destino y adopta
         las garantías adecuadas, 
        contractual o de otra índole, para mitigar los riesgos de cada transferencia de datos personales. En particular, las transferencias de datos personales a países fuera de la Unión Europea se producirán a países que 
        se beneficien de una decisión de idoneidad de la Comisión Europea o si se implementan las Cláusulas Contractuales Tipo aprobadas por la Comisión Europea.</p>
        <p>Puedes ver, en las siguientes tablas, dónde se encuentran cada una de las cookies que utilizamos.</p>`,
        fr: `
        <2>Politique de cookies?</2>       
        <p>Advance Lighting utilise, sur ses sites Web, des cookies qui nous permettent d'améliorer les performances et l'expérience de navigation de nos utilisateurs, en augmentant, d'une part, la rapidité et l'efficacité de la réponse et, d'autre part, en éliminant le 
        devez saisir à plusieurs reprises les mêmes informations. En acceptant la politique de cookies d'Advance Lighting, vous devez tenir compte du fait que l'utilisation de cookies permet une personnalisation de l'utilisation et de la présentation. 
        de services et d'offres adaptés à vos intérêts. Vous pouvez modifier vos paramètres de cookies à tout moment.</p>
        <2>Que sont les cookies?</2>
        <p>Les cookies sont de petits fichiers texte envoyés à votre ordinateur ou appareil mobile lorsque vous visitez des sites Web. Les cookies aident les sites Web à stocker et à récupérer des informations sur vos habitudes de navigation afin de personnaliser 
        navigation selon vos préférences.</p>
        <p>Les cookies peuvent être classés en fonction de la finalité qu'ils servent. Certains cookies sont strictement nécessaires au fonctionnement des <4>sites Web</4>, tandis que d'autres collectent des informations statistiques afin d'analyser l'utilisation. 
        les <4>sites Web</4> et leurs performances ; ou pour assurer la fourniture de fonctionnalités supplémentaires aux <4>sites web;</4> ou encore pour enregistrer les préférences du visiteur concernant la navigation sur ceux-ci. Autres cookies 
        Ils peuvent également être utilisés pour mesurer le succès des candidatures et l’efficacité de la publicité de tiers.</p>
        <2>Comment puis-je gérer les cookies ?</2>
        <p>À l'exception des cookies strictement nécessaires au fonctionnement des <4>sites Web</4>, le stockage des autres cookies dépendra toujours de l'acceptation et du consentement de l'utilisateur.</p>
        <p>Vous pouvez modifier vos paramètres de cookies à tout moment dans l'outil de gestion des préférences en matière de cookies disponible sur les sites Internet Advance Lighting.</p>
        <2>Transfert de données vers des pays hors Union européenne</2>
        <p>L'utilisation de certains Cookies peut impliquer le transfert de données personnelles vers un pays extérieur à l'Union européenne. Advance Lighting garantit vérifier le degré de maturité du pays de destination et adopte les garanties appropriées, 
        nature contractuelle ou autre, pour atténuer les risques de chaque transfert de données personnelles. En particulier, les transferts de données personnelles vers des pays hors de l'Union européenne auront lieu vers des pays bénéficiant d'une décision de
         l'adéquation de la Commission européenne ou si les clauses contractuelles types approuvées par la Commission européenne sont mises en œuvre.</p>
        <p>Vous pouvez voir, dans les tableaux suivants, où se trouve chacun des cookies que nous utilisons.&nbsp;</p>`,
        it: `
        <2>Politica sui cookie?</2>       
        <p>Advance Lighting utilizza, sui propri Siti, cookie che ci consentono di migliorare le prestazioni e l'esperienza di navigazione dei nostri utenti, aumentando, da un lato, la velocità e l'efficienza della risposta e, dall'altro, eliminando il rischio di 
        è necessario inserire ripetutamente le stesse informazioni. Quando si accetta la Politica sui cookie di Advance Lighting, è necessario tenere presente che l'uso dei cookie consente la personalizzazione dell'uso e della presentazione 
        di servizi e offerte adatte ai tuoi interessi. Puoi modificare le impostazioni dei cookie in qualsiasi momento.</p>
        <2>Cosa sono i cookie?</2>
        <p>I cookie sono piccoli file di testo inviati al tuo computer o dispositivo mobile quando visiti siti web. I cookie aiutano i siti Web a memorizzare e recuperare informazioni sulle tue abitudini di navigazione al fine di personalizzare 
        navigazione in base alle tue preferenze.</p>
        <p>I cookie possono essere classificati in base allo scopo che servono. Esistono cookie strettamente necessari per il funzionamento dei <4>siti web</4>, mentre altri raccolgono informazioni statistiche per analizzarne l'utilizzo 
        <4>siti web</4> e loro prestazioni; o per garantire la fornitura di funzionalità aggiuntive ai <4>siti web;</4> o anche per salvare le preferenze del visitatore riguardo alla navigazione sugli stessi. Altri cookie 
        può essere utilizzato anche per misurare il successo delle applicazioni e l'efficacia della pubblicità di terzi.</p>
        <2>Come posso gestire i cookie?</2>
        <p>Ad eccezione dei cookie strettamente necessari per le prestazioni del <4>sito web</4>, la memorizzazione di altri cookie dipenderà sempre dall'accettazione e dal consenso dell'utente.</p>
        <p>È possibile modificare le impostazioni dei cookie in qualsiasi momento nello strumento di gestione delle preferenze dei cookie disponibile sui siti web di Advance Lighting.</p>
        <2>Trasferimento dei dati in paesi non appartenenti all'Unione Europea</2>
        <p>L'utilizzo di alcuni Cookies può comportare il trasferimento di dati personali in un paese al di fuori dell'Unione Europea. Advance Lighting&nbsp;garantisce di verificare il livello di maturità del paese di destinazione e di adottare le garanzie appropriate, 
        contrattuali o di altro tipo, per mitigare i rischi di ogni trasferimento di dati personali. In particolare, i trasferimenti di dati personali verso Paesi al di fuori dell'Unione Europea avverranno verso Paesi che beneficiano di una decisione della
         Commissione Europea o se sono in vigore le Clausole Contrattuali Standard approvate dalla Commissione Europea.</p>
        <p>Nelle tabelle seguenti è possibile vedere dove si trova ciascuno dei cookie che utilizziamo;</p>`,
        zh: `
        <2>Cookie 政策？</2>       
        <p>Advance照明公司在其网站上使用cookies，以改善我们用户的性能和浏览体验，提高响应速度和效率，并消除重复输入相同信息的需要。
        用户无需重复输入相同的信息。在接受Advance Lighting的Cookie政策后，您应牢记，Cookie的使用使我们能够根据您的需求个性化地使用和提供服务和优惠。
        您可以随时更改您的Cookie设置。您可以随时更改 cookie 设置。</p>
        <2>什么是 cookie？</2>
        <p>Cookie 是在您访问网站时发送到您的计算机或移动设备上的小文本文件。Cookie 可帮助网站存储和检索有关您浏览习惯的信息，以便根据您的偏好进行个性化浏览。
        根据您的喜好进行个性化浏览。</p>
        <p>Cookie 可以根据其服务目的进行分类。有些 Cookie 对于<4>网站</4>的运行是绝对必要的，而其他 Cookie 则收集统计信息以分析使用情况 
        <4>网站</4>及其性能；或确保为网站提供附加功能；甚至保存访问者关于网站导航的偏好。其他cookies 
        它们还可用于衡量应用程序的成功和第三方广告的有效性。</p>
        <2>我如何管理 cookie？</2>
        <p>除了<4>网站</4>运行所必需的 cookie 之外，其他 cookie 的存储将始终取决于用户的接受和同意。</p>
        <p>您可以随时在 Advance Lighting 网站上提供的 cookie 首选项管理工具中更改您的 cookie 设置。</p>
        <2>数据传输到欧盟以外的国家</2>
        <p>使用某些 Cookie 可能涉及将个人数据传输到欧盟以外的国家/地区。 Advance Lighting保证验证目的地国家的成熟程度并采取适当的保证， 
        合同或其他性质，以减轻每次个人数据传输的风险。特别是，将个人数据传输到欧盟以外的国家将发生在受益于以下决定的国家：
         欧盟委员会的适用性或欧盟委员会批准的标准合同条款是否得到实施。</p>
        <p>您可以在下表中看到我们使用的每个 Cookie 的位置。</p>`,
      },
    },
]

export const privacyPolicy   = [
  {
    text: { 
      pt: `
            <1>Política de Privacidade</1>
            <p>
            <2>1. INFORMAÇÃO E CONSENTIMENTO</2>
            <3></3>
            </p>

            <4>
            A Lei da Proteção de Dados Pessoais (em diante “LPDP”) e o Regulamento Geral de Proteção de Dados 
            (Regulamento (UE) 2016/679 do Parlamento Europeu e do Conselho de 27 de abril de 2016, em diante “RGPD”) 
            asseguram a proteção das pessoas singulares no que diz respeito ao tratamento de dados pessoais e à livre circulação desses dados.
            </4>

            <4>
            Nos termos legais são considerados “dados pessoais” qualquer informação, de qualquer natureza e independentemente do respetivo suporte, incluindo som e imagem, relativa a uma pessoa singular 
            identificada ou identificável, pelo que a proteção não abrange os dados de pessoas coletivas.
            </4>

            <4>
            Mediante a aceitação da presente Política de Privacidade o utilizador presta o seu consentimento informado, expresso, livre e inequívoco para que os dados pessoais fornecidos através 
            do site https://www.advancelighting.pt/ sejam incluídos num ficheiro da responsabilidade da Advance Lighting, cujo tratamento nos termos da LPDP e do RGPD cumpre as medidas de segurança técnicas e organizativas adequadas.
            </4>

            <4>
            A Advance Lighting, mantém uma base de dados com o registo dos seus clientes. Os dados presentes nesta base são unicamente os dados prestados pelos próprios na altura do seu registo,
            sendo recolhidos e processados automaticamente, nos termos aprovados pela Comissão Nacional de Proteção de Dados, pela Advance Lighting, entidade responsável pelo correspondente ficheiro.
            </4>

            <4>
            Em caso algum será solicitada informação sobre convicções filosóficas ou políticas, filiação partidária ou sindical, fé religiosa, vida privada e origem racial ou étnica bem como os dados relativos à saúde e à vida sexual, incluindo os dados genéticos.
            Em caso algum levaremos a cabo qualquer das seguintes atividades com os dados pessoais que nos sejam facultados através deste site:
            </4>
            <5>
                <6>Ceder a outras pessoas ou outras entidades, sem o consentimento prévio do titular dos dados;</6>
                <6>Transferir para fora do Espaço Económico Europeu (EEE), sem o consentimento prévio do titular dos dados.</6>
            </5>

            <3></3>
            <4>
            <strong>2. FINALIDADES DO TRATAMENTO DE DADOS PESSOAIS</strong>
            <br></br>
            </4>

            <4>Os dados pessoais que tratamos através desta página serão unicamente utilizados para as seguintes finalidades:</4>

            <5>
            (i) Execução e gestão de contrato de compra e venda ou de prestação de serviços;
                <6>(ii) Processamento de encomendas;</6>
                <6>(iii) Comunicação com clientes e esclarecimento de dúvidas;</6>
                <6>(iv) Processamento de pedidos de informação;</6>
                <6>(v) Processamento de reclamações, Processos de Reguladores, Processos pré-contencioso ou exercício de direitos em processos judiciais;</6>
                <6>(vi) Atividades de análise estatística;</6>
                <6>(vii) Verificar, manter e desenvolver sistemas e análises estatísticas;</6>
                <6>(viii) Comunicações de marketing direto (caso tenha consentido no tratamento dos seus dados pessoais para esta finalidade);</6>
                <6>(ix) Prevenção e combate à fraude;</6>
                <6>(x) Solicitação de comentários a produtos ou serviços adquiridos;</6>
                <6>(xi) Realização de inquéritos de satisfação.</6>
                <6>(xii) Gestão e participação em eventos, passatempos e campanhas.</6>
            </5>

            <4>A Advance garante a confidencialidade de todos os dados fornecidos pelos seus clientes. Não obstante a Advance proceder à recolha e ao tratamento de dados de forma segura e que impede a sua perda ou manipulação, 
                utilizando as técnicas mais aperfeiçoadas para o efeito, informamos que a recolha em rede aberta permite a circulação dos dados pessoais sem condições de segurança, correndo o risco de ser vistos e utilizados por terceiros não autorizados.</4>

            <4>Por outro lado, o utilizador consente que se possa aceder à informação relativa ao serviço contratado com a Advance Lighting com o fim de lhe poder oferecer serviços adicionais ao contratado.</4>

            <4>No momento da recolha dos dados pessoais, salvo nos campos em que for indicado o contrário, o utilizador poderá, voluntariamente, disponibilizar os dados pessoais, sem que a falta de resposta implique um decréscimo na qualidade 
            ou quantidade dos serviços correspondentes (a menos que esteja indicada outra coisa). Não obstante, a falta de resposta aos dados, considerados obrigatórios, implicará a impossibilidade de aceder ao serviço para o qual os dados foram solicitados.</4>

            <4>Caso não concorde com as condições acima referidas, a Advance Lighting não poderá contratar com o utilizador através da sua página Web.</4>

            <4>
            <2>3. CESSÃO DE DADOS PESSOAIS</2>
            <3></3>
            </4>

            <4>Por forma a poder cumprir com o objeto do presente website, a Advance Lighting irá ceder os seus dados pessoais a outras entidades, que os irão tratar, para as seguintes finalidades:</4>

            <5>
                <6>Atividades de gestão e processamento de pagamentos;</6>
                <6>Prestação dos serviços contratados.</6>
                <6>Gestão e participação em eventos, passatempos e campanhas.</6>
            </5>

            <4>As entidades a quem a Advance Lighting irá ceder os seus dados pessoais para os tratarem nos termos acima referidos terão a seguinte natureza:</4>

            <5>
                <6>Entidades seguradoras;</6>
                <6>Entidades terceiras relacionadas com a prestação dos serviços contratados;</6>
                <6>Entidades de gestão e processamento de pagamentos.</6>
            </5>
            <3></3>
            <4>
            <2>4. MEDIDAS DE SEGURANÇA</2>
            <3></3>
            </4>

            <4>A Advance Lighting declara que implementou e continuará a implementar as medidas de segurança de natureza técnica e organizativa necessárias para garantir a segurança dos dados de carácter pessoal
             que lhe sejam fornecidos visando evitar a sua alteração, perda, tratamento e/ou acesso não autorizado, tendo em conta o estado atual da tecnologia, a natureza dos dados armazenados e os riscos a que estão expostos.</4>

             <4>A Advance Lighting garante a confidencialidade de todos os dados fornecidos pelos seus clientes quer no registo, quer no processo de compra/encomenda de produtos ou serviços. A recolha e tratamento de dados realiza-se de 
                forma segura e que impede a sua perda ou manipulação. Todos os dados serão inseridos num Servidor Seguro (SSL de 128 bits) que os encripta/codifica (transforma num código). O utilizador poderá verificar que o seu browser 
                é seguro se o símbolo do cadeado aparecer ou se o endereço começar com https em vez de http.</4>

            <4>Os dados pessoais são tratados com o nível de proteção legalmente exigível para garantir a segurança dos mesmos e evitar a sua alteração, perda, tratamento ou acesso não autorizado, tendo em conta o estado da tecnologia, 
            sendo o utilizador consciente e aceitando que as medidas de segurança em Internet não são inexpugnáveis.</4>

            <4>A Advance Lighting, sempre que aceda a qualquer dado pessoal, compromete-se a:</4>   

            <4>Armazená-los por intermédio de medidas de segurança, legalmente exigíveis, de natureza técnica e organizacional, que garantam a sua segurança, evitando assim a alteração, perda, tratamento ou acesso não autorizado,
                 em conformidade com o estado da tecnologia em cada momento, a natureza dos dados e os possíveis riscos a que estejam expostos;</4>

            <4>Utilizar os dados exclusivamente para as finalidades previamente definidas;</4>  

            <4>Certificar-se de que os dados são tratados unicamente pelos trabalhadores cuja intervenção seja necessária para a prestação do serviço estando os mesmos obrigados ao dever de sigilo e confidencialidade.
             Existindo a possibilidade de a informação ser revelada a terceiros, estes devem ser obrigados a guardar a devida confidencialidade em conformidade com o previsto neste documento.</4>  

             <3></3>
            <4>
            <2>5. COMUNICAÇÕES COMERCIAIS E PROMOCIONAIS</2>
            <3></3>
            </4>

            <4>Um dos propósitos para os quais tratamos dados pessoais fornecidos pelos utilizadores é enviar comunicações eletrónicas com informações relativas a comunicações comerciais e promocionais.</4>  

            <4>Sempre que fizermos uma comunicação deste tipo, será direcionado exclusivamente aos utilizadores que as tenham autorizado previamente e de forma expressa.</4>  

            <4>De acordo com o disposto na Decreto-Lei n.º 7/2004, de 7 de janeiro, no caso de o utilizador desejar deixar de receber comunicações comerciais ou promocionais da Advance Lighting, 
            poderá solicitar a oposição do serviço enviando um e-mail para o seguinte formulário Web: <a href='/Contactos'>www.advancelighting.pt/contactos</a></4>  

            <3></3>
            <4>
            <2>6. EXERCÍCIO DOS DIREITOS</2>
            <3></3>
            </4>

            <4>De acordo com as disposições da LDPD e do RGPD, o utilizador pode exercer a todo o tempo os seus direitos de acesso, retificação, apagamento, limitação, oposição e portabilidade, através de solicitação por:</4>  
            <5>
            <6><7 href="mailto:info@gruporr.pt">info@gruporr.pt</7> </6>
            </5>

            <3></3>
            <4>Caso o utilizador deseje, a qualquer momento, deixar de fazer parte da base de dados Advance poderá exercer esse direito através deste contacto.</4> `,

      en: `   
      <1>Privacy Policy</1>
            <p>
            <2>1. INFORMATION AND CONSENT</2>
            <3></3>
            </p>

            <4>
            The Personal Data Protection Law (hereinafter “LPDP”) and the General Data Protection Regulation 
            (Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016, hereinafter “GDPR”) 
            ensure the protection of natural persons with regard to the processing of personal data and the free movement of such data.
            </4>
            <4>
            In legal terms, “personal data” means any information, of any nature and regardless of its support, including sound and image, relating to a natural person. 
            identified or identifiable, meaning that protection does not cover the data of legal persons.
            </4>

            <4>
            By accepting this Privacy Policy, the user provides their informed, express, free and unequivocal consent for the personal data provided through 
            from the website https://www.advancelighting.pt/ are included in a file under the responsibility of Advance Lighting, whose processing under the terms of the LPDP and the GDPR complies with appropriate technical and organizational security measures.
            </4>
            
            <4>
            Advance Lighting maintains a database with records of its customers. The data present in this database are solely the data provided by them at the time of registration,
            being collected and processed automatically, under the terms approved by the National Data Protection Commission, by Advance Lighting, the entity responsible for the corresponding file.
            </4>

            <4>
            Under no circumstances will information be requested about philosophical or political beliefs, party or trade union affiliation, religious faith, private life and racial or ethnic origin as well as data relating to health and sexual life, including genetic data.
            Under no circumstances will we carry out any of the following activities with the personal data provided to us through this website:
            </4>
            <5>
                <6>Give to other people or other entities, without the prior consent of the data subject;</6>
                <6>Transfer outside the European Economic Area (EEA), without the prior consent of the data subject.</6>
            </5>

            <3></3>
            <4>
            <strong>2. PURPOSES OF PROCESSING PERSONAL DATA</strong>
            <br></br>
            </4>

            <4>The personal data we process through this page will only be used for the following purposes:</4>
            <5>
            (i) Execution and management of purchase and sale or service provision contracts;
                <6>(ii) Order processing;</6>
                <6>(iii) Communication with customers and clarification of doubts;</6>
                <6>(iv) Processing of information requests;</6>
                <6>(v) Complaints processing, Regulatory Processes, Pre-litigation processes or exercise of rights in legal proceedings;</6>
                <6>(vi) Statistical analysis activities;</6>
                <6>(vii) Verify, maintain and develop statistical systems and analyses;</6>
                <6>(viii) Direct marketing communications (if you have consented to the processing of your personal data for this purpose);</6>
                <6>(ix) Preventing and combating fraud;</6>
                <6>(x) Request for comments on purchased products or services;</6>
                <6>(xi) Carrying out satisfaction surveys.</6>
                <6>(xii) Management and participation in events, competitions and campaigns.</6>
            </5>
            
            <4>Advance guarantees the confidentiality of all data provided by its customers. Although Advance collects and processes data in a secure manner that prevents its loss or manipulation, 
                using the most advanced techniques for this purpose, we would like to inform you that collection on an open network allows personal data to circulate without security conditions, running the risk of it being seen and used by unauthorised third parties.</4>

            <4>On the other hand, the user consents to access to information regarding the service contracted with Advance Lighting in order to offer additional services to the contracted service.</4>

            <4>When personal data is collected, except in fields where otherwise indicated, the user may voluntarily provide personal data, without the lack of response implying a decrease in the quality or quantity of the corresponding services (unless otherwise indicated). 
            or quantity of the corresponding services (unless otherwise stated). However, failure to respond to the data, which is considered mandatory, will result in the impossibility of accessing the service for which the data was requested.</4>

            <4>If you do not agree with the above conditions, Advance Lighting will not be able to contract with you via its website.</4> 
            
            <4>
            <2>3. TRANSFER OF PERSONAL DATA</2>
            <3></3>
            </4>

            <4>In order to fulfil the purpose of this website, Advance Lighting will transfer your personal data to other entities, which will process it for the following purposes:</4>

            <5>
                <6>Payment management and processing activities;</6>
                <6>Providing contracted services.</6>
                <6>Management of and participation in events, competitions and campaigns.</6>
            </5>

            <4>The entities to which Advance Lighting will transfer your personal data in order to process it under the above terms will be of the following nature:</4>

            <5>
                <6>Insurance organisations;</6>
                <6>Third parties related to the provision of contracted services;</6>
                <6>Payment management and processing organisations.</6>
            </5>
            <3></3>
            <4>
            <2>4. SECURITY MEASURES</2>
            <3></3>
            </4>
            
             <4>Advance Lighting declares that it has implemented and will continue to implement the technical and organisational security measures necessary to guarantee the security of personal data provided to it in order to prevent its alteration, loss, processing and/or unauthorised access.
             provided to it in order to prevent its alteration, loss, processing and/or unauthorised access, taking into account the current state of technology, the nature of the data stored and the risks to which they are exposed.</4>

             <4>Advance Lighting guarantees the confidentiality of all data provided by its customers, both when registering and when purchasing/ordering products or services. Data is collected and processed in a 
                data is collected and processed in a secure manner that prevents its loss or manipulation. All data is entered into a secure server (128-bit SSL) which encrypts it (transforms it into a code). Users can check that their browser 
                is secure if the padlock symbol appears or if the address begins with https instead of http.</4>

            <4>Personal data is processed with the level of protection legally required to guarantee its security and prevent its alteration, loss, processing or unauthorised access, taking into account the state of the art, 
            The user is aware and accepts that Internet security measures are not impregnable.</4>

            <4>Advance Lighting, whenever it accesses any personal data, undertakes to:</4>   

            <4>Store them by means of legally required security measures of a technical and organisational nature that guarantee their security, thus preventing alteration, loss, processing or unauthorised access,
                 in accordance with the state of the art at any given time, the nature of the data and the possible risks to which it is exposed;</4>

            <4>Use the data exclusively for the purposes previously defined;</4>  

            <4>Make sure that the data is only processed by the workers whose intervention is necessary for the provision of the service, and that they are bound by the duty of secrecy and confidentiality.
             If the information may be disclosed to third parties, they must be obliged to keep it confidential in accordance with the provisions of this document.</4>  
             <3></3> 
             <4>
            <2>6. EXERCISE OF RIGHTS</2>
            <3></3>
            </4>

            <4>In accordance with the provisions of the LDPD and the GDPR, the user can exercise their rights of access, rectification, erasure, limitation, opposition and portability at any time, through a request by:</4>  
            <5>
            <6><7 href="mailto:info@gruporr.pt">info@gruporr.pt</7> </6>
            </5>

            <3></3>
            <4>If the user wishes, at any time, to stop being part of the Advance database, they can exercise this right through this contact.</4>`,
      es: `
      <1>Política de privacidad</1>
            <p>
            <2>1. INFORMACIÓN Y CONSENTIMIENTO</2>
            <3></3>
            </p>

            <4>
            La Ley de Protección de Datos Personales (en adelante “LPDP”) y el Reglamento General de Protección de Datos 
            (Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, en adelante “GDPR”) 
            garantizar la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de dichos datos.
            </4>
            <4>
            En términos jurídicos, se entiende por “dato personal” cualquier información, de cualquier naturaleza e independientemente de su soporte, incluido el sonido y la imagen, relativa a una persona física. 
            identificados o identificables, por lo que la protección no cubre los datos de personas jurídicas.
            </4>

            <4>
            Al aceptar esta Política de Privacidad, el usuario proporciona su consentimiento informado, expreso, libre e inequívoco para los datos personales que proporcione a través de 
            del sitio web https://www.advancelighting.pt/ se incluyen en un fichero responsabilidad de Advance Lighting, cuyo tratamiento en los términos de la LPDP y el RGPD cumple con las medidas de seguridad técnicas y organizativas apropiadas.
            </4>
            <4>
            Advance Lighting mantiene una base de datos con registros de sus clientes. Los datos presentes en esta base de datos son únicamente los datos proporcionados por ellos en el momento del registro,
            siendo recabados y tratados de forma automatizada, en los términos aprobados por la Comisión Nacional de Protección de Datos, por Advance Lighting, entidad responsable del fichero correspondiente.
            </4>

            <4>
            En ningún caso se solicitará información sobre creencias filosóficas o políticas, afiliación partidista o sindical, fe religiosa, vida privada y origen racial o étnico, así como datos relativos a la salud y la vida sexual, incluidos datos genéticos.
            En ningún caso realizaremos ninguna de las siguientes actividades con los datos personales que nos facilitan a través de este sitio web:
            </4>
            <5>
                <6>Dar a otras personas u otras entidades, sin el consentimiento previo del interesado;</6>
                <6>Transferencia fuera del Espacio Económico Europeo (EEE), sin el consentimiento previo del interesado.</6>
            </5>
            
            <3></3>
            <4>
            <2>2. FINALIDADES DEL TRATAMIENTO DE DATOS PERSONALES</2>
            <3></3>
            </4>

            <4>Los datos personales que procesamos a través de esta página sólo se utilizarán para las siguientes finalidades:</4>
            <5>
            (i) Celebración y gestión de contratos de compraventa o de prestación de servicios;
                <6>(ii) Procesamiento de pedidos;</6>
                <6>(iii) Comunicación con clientes y aclaración de dudas;</6>
                <6>(iv) Tramitación de solicitudes de información;</6>
                <6>(v) Tramitación de quejas, Procesos Regulatorios, Procesos previos al litigio o ejercicio de derechos en procesos judiciales;</6>
                <6>(vi) Actividades de análisis estadístico;</6>
                <6>(vii) Verificar, mantener y desarrollar sistemas y análisis estadísticos;</6>
                <6>(viii) Comunicaciones de marketing directo (si ha dado su consentimiento para el procesamiento de sus datos personales para este fin);</6>
                <6>(ix) Prevención y lucha contra el fraude;</6>
                <6>(x) Solicitud de comentarios sobre productos o servicios adquiridos;</6>
                <6>(xi) Realización de encuestas de satisfacción.</6>
                <6>(xii) Gestión y participación en eventos, concursos y campañas.</6>
            </5>
            
            <4>Advance garantiza la confidencialidad de todos los datos facilitados por sus clientes. Aunque Advance recoge y trata los datos de forma segura, evitando su pérdida o manipulación, 
                utilizando para ello las técnicas más avanzadas, le informamos que la recogida en red abierta permite que los datos personales circulen sin condiciones de seguridad, corriendo el riesgo de ser vistos y utilizados por terceros no autorizados.</4>

            <4>Por otro lado, el usuario consiente el acceso a información relativa al servicio contratado con Advance Lighting con la finalidad de ofrecer servicios adicionales al servicio contratado.</4>

            <4>En el momento de proceder a la recogida de los datos personales, salvo en los campos en que se indique lo contrario, el usuario podrá proporcionar voluntariamente sus datos personales, sin que la falta de respuesta implique una merma en la calidad o cantidad de los correspondientes servicios (a menos que se indique otra cosa). 
            o cantidad de los correspondientes servicios (salvo que se indique otra cosa). No obstante, la falta de respuesta a la solicitud de los datos calificados como obligatorios supondrá la imposibilidad de acceder al servicio para los que eran solicitados.</4>

            <4>Si no está de acuerdo con las condiciones anteriores, Advance Lighting no podrá contratar con usted a través de su página web.</4> 
                 <4>
            <2>3. TRANSFERENCIA DE DATOS PERSONALES</2>
            <3></3>
            </4>

            <4>Para el cumplimiento de la finalidad de este sitio web, Advance Lighting cederá sus datos personales a otras entidades, que los tratarán para las siguientes finalidades:</4>

            <5>
                <6>Actividades de gestión y tramitación de pagos;</6>
                <6>Prestación de servicios contratados.</6>
                <6>Gestión y participación en eventos, concursos y campañas.</6>
            </5>

            <4>Las entidades a las que Advance Lighting transferirá sus datos personales para tratarlos en los términos anteriores serán de la siguiente naturaleza:</4>

            <5>
                <6>Organizaciones aseguradoras;</6>
                <6>Terceros relacionados con la prestación de los servicios contratados;</6>
                <6>Organismos de gestión y tramitación de pagos.</6>
            </5>
            <3></3>
            <4>
            <2>4. MEDIDAS DE SEGURIDAD</2>
            <3></3>
            </4>
            
              <4>Advance Lighting declara que tiene implantadas y mantendrá las medidas de seguridad de índole técnica y organizativas necesarias que garanticen la seguridad de los datos de carácter personal que le sean facilitados con el fin de evitar su alteración, pérdida, tratamiento y/o acceso no autorizado.
             Los datos de carácter personal que le sean facilitados serán tratados con las medidas de seguridad necesarias para evitar su alteración, pérdida, tratamiento y/o acceso no autorizado, habida cuenta del estado de la tecnología, la naturaleza de los datos almacenados y los riesgos a que están expuestos.</4>

             <4>Advance Lighting garantiza la confidencialidad de todos los datos facilitados por sus clientes, tanto en el momento del registro como en el de la contratación de productos o servicios. Los datos se recogen y procesan en un 
                Los datos se recogen y procesan de forma segura para evitar su pérdida o manipulación. Todos los datos se introducen en un servidor seguro (SSL de 128 bits) que los encripta (los transforma en un código). Los usuarios pueden comprobar que su navegador 
                es seguro si aparece el símbolo del candado o si la dirección empieza por https en lugar de http.</4>

            <4>Los datos de carácter personal son tratados con el nivel de protección legalmente requerido para garantizar su seguridad y evitar su alteración, pérdida, tratamiento o acceso no autorizado, habida cuenta del estado de la tecnología, 
            El usuario es consciente y acepta que las medidas de seguridad en Internet no son inexpugnables.</4>

            <4>Advance Lighting, siempre que acceda a algún dato de carácter personal, se compromete a:</4>   

            <4>Guardarlos bajo las medidas de seguridad de índole técnica y organizativas legalmente requeridas, que garanticen su seguridad y eviten su alteración, pérdida, tratamiento o acceso no autorizado,
                 de acuerdo con el estado de la tecnología en cada momento, la naturaleza de los datos y los posibles riesgos a que estén expuestos;</4>

            <4>Utilizar los datos exclusivamente para los fines anteriormente definidos;</4>  

            <4>Asegurarse de que los datos sólo sean tratados por los trabajadores cuya intervención sea necesaria para la prestación del servicio, y de que estén sujetos al deber de secreto y confidencialidad.
             En caso de que los datos puedan ser comunicados a terceros, éstos deberán estar obligados a guardar secreto de los mismos conforme a lo establecido en el presente documento.</4>
              <3></3>
              <4>
            <2>6. EJERCICIO DE DERECHOS</2>
            <3></3>
            </4>

            <4>De conformidad con lo establecido en la LDPD y el RGPD, el usuario puede ejercitar sus derechos de acceso, rectificación, supresión, limitación, oposición y portabilidad en cualquier momento, mediante solicitud dirigida a:</4>  
            <5>
            <6><7 href="mailto:info@gruporr.pt">info@gruporr.pt</7> </6>
            </5>

            <3></3>
            <4>Si el usuario desea, en cualquier momento, dejar de formar parte de la base de datos de Advance, puede ejercer este derecho a través de este contacto.</4>`,
      fr: `
      <1>Politique de confidentialité</1>
            <p>
            <2>1. INFORMATION ET CONSENTEMENT</2>
            <3></3>
            </p>

            <4>
            La Loi Protection des Données Personnelles (ci-après « LPDP ») et le Règlement Général sur la Protection des Données 
            (Règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016, ci-après « RGPD ») 
            assurer la protection des personnes physiques à l'égard du traitement des données à caractère personnel et la libre circulation de ces données.
            </4>
            <4>
            En termes juridiques, « données personnelles » désigne toute information, de quelque nature que ce soit et quel que soit son support, y compris le son et l'image, relative à une personne physique. 
            identifiées ou identifiables, ce qui signifie que la protection ne couvre pas les données des personnes morales.
            </4>

            <4>
            En acceptant cette politique de confidentialité, l'utilisateur donne son consentement éclairé, exprès, libre et sans équivoque pour les données personnelles fournies via 
            provenant du site https://www.advancelighting.pt/ sont inclus dans un fichier sous la responsabilité d'Advance Lighting, dont le traitement au titre de la LPDP et du RGPD respecte les mesures de sécurité techniques et organisationnelles appropriées.
            </4>
            <4>
            Advance Lighting maintient une base de données avec les enregistrements de ses clients. Les données présentes dans cette base de données sont uniquement les données fournies par ceux-ci au moment de l'inscription,
            étant collectées et traitées automatiquement, dans les conditions approuvées par la Commission Nationale de Protection des Données, par Advance Lighting, l'entité responsable du fichier correspondant.
            </4>

            <4>
            En aucun cas, des informations ne seront demandées sur les convictions philosophiques ou politiques, l'affiliation à un parti ou à un syndicat, la foi religieuse, la vie privée et l'origine raciale ou ethnique ainsi que les données relatives à la santé et à la vie sexuelle, y compris les données génétiques.
            En aucun cas nous n'effectuerons l'une des activités suivantes avec les données personnelles qui nous sont fournies via ce site Web :
            </4>
            <5>
                <6>Donner à d'autres personnes ou d'autres entités, sans le consentement préalable de la personne concernée ;</6>
                <6>Transfert en dehors de l'Espace économique européen (EEE), sans le consentement préalable de la personne concernée.</6>
            </5>
            
            <3></3>
            <4>
            <2>2. FINALITÉS DU TRAITEMENT DE DONNÉES PERSONNELLES</2>
            <3></3>
            </4>

            <4>Les données personnelles que nous traitons via cette page ne seront utilisées qu'aux fins suivantes :</4>
            <5>
            (i) Exécution et gestion de contrats d'achat et de vente ou de prestation de services ;
                <6>(ii) Traitement des commandes ;</6>
                <6>(iii) Communication avec les clients et clarification des doutes ;</6>
                <6>(iv) Traitement des demandes d'informations ;</6>
                <6>(v) Traitement des réclamations, processus réglementaires, processus précontentieux ou exercice des droits dans le cadre d'une procédure judiciaire ;</6>
                <6>(vi) Activités d'analyse statistique ;</6>
                <6>(vii) Vérifier, maintenir et développer des systèmes et des analyses statistiques ;</6>
                <6>(viii) Communications de marketing direct (si vous avez consenti au traitement de vos données personnelles à cette fin) ;</6>
                <6>(ix) Prévenir et combattre la fraude ;</6>
                <6>(x) Demande de commentaires sur les produits ou services achetés ;</6>
                <6>(xi) Réalisation d'enquêtes de satisfaction.</6>
                <6>(xii) Gestion et participation à des événements, concours et campagnes.</6>
            </5>
            
           <4>Advance garantit la confidentialité de toutes les données fournies par ses clients. Bien qu'Advance collecte et traite les données en toute sécurité, empêchant leur perte ou leur manipulation, 
                En utilisant pour cela les techniques les plus avancées, nous vous informons que la collecte en réseau ouvert permet aux données personnelles de circuler sans conditions de sécurité, risquant d'être vues et utilisées par des tiers non autorisés.</4>

            <4>D'autre part, l'utilisateur consent à accéder aux informations relatives au service contracté avec Advance Lighting afin d'offrir des services supplémentaires au service contracté.</4>

            <4>Lorsque des données personnelles sont collectées, sauf dans les champs où il est indiqué autrement, l'utilisateur peut fournir volontairement des données personnelles, sans que l'absence de réponse n'implique une diminution de la qualité ou de la quantité des services correspondants (sauf indication contraire). 
            L'absence de réponse n'implique pas une diminution de la qualité ou de la quantité des services correspondants (sauf indication contraire). Toutefois, le défaut de réponse aux données, considéré comme obligatoire, entraînera l'impossibilité d'accéder au service pour lequel les données ont été demandées.</4>

            <4>Si vous n'acceptez pas les conditions ci-dessus, Advance Lighting ne pourra pas contracter avec vous via son site web.<4>
            <4>
            <2>3. TRANSFERT DE DONNEES A CARACTERE PERSONNEL</2>
            <3></3>
            </4>

            <4>Afin de remplir l'objectif de ce site web, Advance Lighting transférera vos données personnelles à d'autres entités, qui les traiteront aux fins suivantes :</4>

            <5>
                <6>Gestion des paiements et activités de traitement;</6>
                <6>Fourniture de services sous contrat.</6>
                <6>Gestion d'événements, de concours et de campagnes et participation à ceux-ci.</6>
            </5>

            <4>Les entités auxquelles Advance Lighting transférera vos données à caractère personnel afin de les traiter dans les conditions susmentionnées seront de la nature suivante :</4>

            <5>
                <6>Organismes d'assurance;</6>
                <6>Tiers liés à la fourniture de services contractuels;</6>
                <6>Organismes de gestion et de traitement des paiements.</6>
            </5>
            <3></3>
            <4>
            <2>4. MESURES DE SECURITE</2>
            <3></3>
            </4>
            
              <4>Advance Lighting déclare qu'elle a mis et continuera à mettre en œuvre les mesures de sécurité techniques et organisationnelles nécessaires pour garantir la sécurité des données personnelles qui lui sont fournies afin d'empêcher leur altération, perte, traitement et/ou accès non autorisé.
             Les mesures de sécurité techniques et organisationnelles nécessaires pour garantir la sécurité des données à caractère personnel qui lui sont fournies afin d'empêcher leur altération, perte, traitement et/ou accès non autorisé, compte tenu de l'état actuel de la technologie, de la nature des données stockées et des risques auxquels elles sont exposées.</4>

             <4>Advance Lighting garantit la confidentialité de toutes les données fournies par ses clients, tant lors de l'enregistrement que lors de l'achat/commande de produits ou de services. Les données sont collectées et traitées dans un 
                Les données sont collectées et traitées de manière sécurisée afin d'éviter leur perte ou leur manipulation. Toutes les données sont introduites dans un serveur sécurisé (SSL 128 bits) qui les crypte (les transforme en code). L'utilisateur peut vérifier que son navigateur 
                est sécurisé si le symbole du cadenas apparaît ou si l'adresse commence par https au lieu de http.</4>

            Les données personnelles sont traitées avec le niveau de protection légalement requis pour garantir leur sécurité et empêcher leur altération, perte, traitement ou accès non autorisé, compte tenu de l'état de la technique, 
            L'utilisateur est conscient et accepte que les mesures de sécurité sur Internet ne sont pas inexpugnables.

            L'utilisateur est conscient et accepte que les mesures de sécurité sur Internet ne sont pas infaillibles.<4>Advance Lighting, chaque fois qu'elle accède à des données personnelles, s'engage à :</4>   

            <4>Les stocker au moyen de mesures de sécurité légalement requises de nature technique et organisationnelle qui garantissent leur sécurité, empêchant ainsi l'altération, la perte, le traitement ou l'accès non autorisé,
                 en fonction de l'état de l'art à tout moment, de la nature des données et des risques éventuels auxquels elles sont exposées;</4>

            <4>Utiliser les données exclusivement pour les finalités préalablement définies ;</4>  

            S'assurer que les données ne sont traitées que par les travailleurs dont l'intervention est nécessaire à la fourniture du service, et qu'ils sont tenus au secret et à la confidentialité.
             Si les informations peuvent être divulguées à des tiers, ceux-ci doivent être tenus de les garder confidentielles conformément aux dispositions du présent document.</4>
              <3></3>
            <4>
            <2>6. EXERCICE DES DROITS</2>
            <3></3>
            </4>

            <4>Conformément aux dispositions de la LDPD et du RGPD, l'utilisateur peut exercer ses droits d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité à tout moment, par le biais d'une demande adressée par :</4>  
            <5>
            <6><7 href="mailto:info@gruporr.pt">info@gruporr.pt</7> </6>
            </5>

            <3></3>
            <4>Si l'utilisateur souhaite, à tout moment, cesser de faire partie de la base de données Advance, il peut exercer ce droit via ce contact.</4>`,
      it: `
          <1>Informativa sulla privacy</1>
            <p>
            <2>1. INFORMATIVA E CONSENSO</2>
            <3></3>
            </p>

            <4>
            La legge sulla protezione dei dati personali (di seguito “LPDP”) e il regolamento generale sulla protezione dei dati 
            (Regolamento (UE) 2016/679 del Parlamento Europeo e del Consiglio del 27 aprile 2016, di seguito “GDPR”) 
            garantire la tutela delle persone fisiche con riguardo al trattamento dei dati personali e la libera circolazione di tali dati.
            </4>
            <4>
            In termini giuridici, per “dato personale” si intende qualsiasi informazione, di qualsiasi natura e indipendentemente dal suo supporto, compresi suoni e immagini, relativa a una persona fisica. 
            identificati o identificabili, nel senso che la tutela non si estende ai dati delle persone giuridiche.
            </4>

            <4>
            Accettando la presente Informativa sulla Privacy, l'utente fornisce il proprio consenso informato, espresso, libero e inequivocabile per i dati personali forniti attraverso 
            dal sito web https://www.advancelighting.pt/ sono inclusi in un file sotto la responsabilità di Advance Lighting, il cui trattamento ai sensi della LPDP e del GDPR è conforme ad adeguate misure di sicurezza tecniche e organizzative.
            </4>
            <4>
            Advance Lighting mantiene un database con i record dei propri clienti. I dati presenti in questo database sono esclusivamente quelli da loro forniti al momento della registrazione,
            vengono raccolti ed elaborati automaticamente, secondo i termini approvati dalla Commissione nazionale per la protezione dei dati, da Advance Lighting, l'entità responsabile del file corrispondente.
            </4>

            <4>
            In nessun caso verranno richieste informazioni relative alle convinzioni filosofiche o politiche, all'appartenenza partitica o sindacale, alla fede religiosa, alla vita privata e all'origine razziale o etnica nonché dati relativi alla salute e alla vita sessuale, compresi i dati genetici.
            In nessun caso svolgeremo nessuna delle seguenti attività con i dati personali fornitici attraverso questo sito web:
            </4>
            <5>
                <6>Conferire ad altre persone o altri soggetti, senza il preventivo consenso dell'interessato;</6>
                <6>Trasferimento al di fuori dello Spazio Economico Europeo (SEE), senza il previo consenso dell'interessato.</6>
            </5>
            
            <3></3>
            <4>
            <strong>2. FINALITÀ DEL TRATTAMENTO DEI DATI PERSONALI</strong>
            <br></br>
            </4>

            <4>I dati personali che elaboriamo attraverso questa pagina verranno utilizzati solo per i seguenti scopi:</4>
                        <5>
            (i) Esecuzione e gestione di contratti di compravendita o di fornitura di servizi;
                <6>(ii) Elaborazione degli ordini;</6>
                <6>(iii) comunicare con i clienti e rispondere alle domande;</6>
                <6>(iv) Elaborazione delle richieste di informazioni;</6>
                <6>(v) Elaborazione di reclami, procedimenti normativi, procedimenti precontenziosi o esercizio di diritti in procedimenti giudiziari;</6>
                <6>(vi) attività di analisi statistica;</6>
                <6>(vii) Verifica, manutenzione e sviluppo di sistemi e analisi statistiche;</6> (vii) Attività di analisi statistica
                <6>(viii) Comunicazioni di marketing diretto (se avete acconsentito al trattamento dei vostri dati personali per questo scopo);</6>
                <6>(ix) Prevenzione e lotta contro la frode;</6>
                <6>(x) Richiesta di commenti su prodotti o servizi acquistati;</6>
                <6>(xi) Effettuare sondaggi sulla soddisfazione;</6>
                <6>(xii) Gestione e partecipazione a eventi, concorsi e campagne.</6>
            </5>
            <4>Advance garantisce la riservatezza di tutti i dati forniti dai suoi clienti. Sebbene Advance raccolga ed elabori i dati in modo sicuro per evitarne la perdita o la manipolazione, 
                utilizzando a tal fine le tecniche più avanzate, desideriamo informarvi che la raccolta su una rete aperta consente ai dati personali di circolare senza condizioni di sicurezza, correndo il rischio di essere visti e utilizzati da terze parti non autorizzate.</4>

            <4>D'altra parte, l'utente acconsente all'accesso alle informazioni relative al servizio stipulato con Advance Lighting al fine di offrire servizi aggiuntivi al servizio stipulato.</4>

            <4>Quando vengono raccolti dati personali, ad eccezione dei campi in cui è indicato diversamente, l'utente può fornire volontariamente i dati personali, senza che la mancata risposta implichi una diminuzione della qualità o della quantità dei servizi corrispondenti (a meno che non sia indicato diversamente). 
            o della quantità dei servizi corrispondenti (salvo diversa indicazione). Tuttavia, la mancata risposta ai dati, che è considerata obbligatoria, comporterà l'impossibilità di accedere al servizio per cui i dati sono stati richiesti.</4>

            <4>Se non accettate le condizioni di cui sopra, Advance Lighting non sarà in grado di contrattare con voi attraverso il suo sito web.</4>
            
            <4>Advance garantisce la riservatezza di tutti i dati forniti dai suoi clienti. Sebbene Advance raccolga ed elabori i dati in modo sicuro per evitarne la perdita o la manipolazione, 
                utilizzando a tal fine le tecniche più avanzate, desideriamo informarvi che la raccolta su una rete aperta consente ai dati personali di circolare senza condizioni di sicurezza, correndo il rischio di essere visti e utilizzati da terze parti non autorizzate.</4>

            <4>D'altra parte, l'utente acconsente all'accesso alle informazioni relative al servizio stipulato con Advance Lighting al fine di offrire servizi aggiuntivi al servizio stipulato.</4>

            <4>Quando vengono raccolti dati personali, ad eccezione dei campi in cui è indicato diversamente, l'utente può fornire volontariamente i dati personali, senza che la mancata risposta implichi una diminuzione della qualità o della quantità dei servizi corrispondenti (a meno che non sia indicato diversamente). 
            o della quantità dei servizi corrispondenti (salvo diversa indicazione). Tuttavia, la mancata risposta ai dati, che è considerata obbligatoria, comporterà l'impossibilità di accedere al servizio per cui i dati sono stati richiesti.</4>

            <4>Se non accettate le condizioni di cui sopra, Advance Lighting non sarà in grado di contrattare con voi attraverso il suo sito web.</4>
              <4>
            <2>3. TRASFERIMENTO DEI DATI PERSONALI</2>
            <3></3>
            </4>

            <4>Per adempiere alle finalità di questo sito web, Advance Lighting trasferirà i vostri dati personali ad altre entità, che li tratteranno per le seguenti finalità:</4>

            <5>
                <6>Attività di gestione ed elaborazione dei pagamenti;</6>
                <6>Fornitura di servizi a contratto.</6>
                <6>Gestione e partecipazione a eventi, concorsi e campagne.</6>
            </5>

            <4>Le entità a cui Advance Lighting trasferirà i vostri dati personali per trattarli ai sensi dei termini di cui sopra saranno della seguente natura:</4>

            <5>
                <6>Organizzazioni di assicurazione;</6>
                <6>Terze parti relative alla fornitura di servizi contrattuali;</6>
                <6>Organizzazioni di gestione ed elaborazione dei pagamenti.</6>
            </5>
            <3></3>
            <4>
            <2>4. MISURE DI SICUREZZA</2>
            <3></3>
            </4>
                        <4>Advance Lighting dichiara di aver implementato e continuerà ad implementare le misure di sicurezza tecniche e organizzative necessarie a garantire la sicurezza dei dati personali che le sono stati forniti al fine di impedirne l'alterazione, la perdita, il trattamento e/o l'accesso non autorizzato.
             I dati personali forniti alla società al fine di prevenirne l'alterazione, la perdita, l'elaborazione e/o l'accesso non autorizzato, tenendo conto dello stato attuale della tecnologia, della natura dei dati memorizzati e dei rischi a cui sono esposti.</4>

             <4>Advance Lighting garantisce la riservatezza di tutti i dati forniti dai propri clienti, sia in fase di registrazione che di acquisto/ordine di prodotti o servizi. I dati vengono raccolti ed elaborati in un 
                I dati vengono raccolti ed elaborati in modo sicuro per evitarne la perdita o la manipolazione. Tutti i dati vengono inseriti in un server sicuro (SSL a 128 bit) che li cripta (li trasforma in un codice). Gli utenti possono verificare che il loro browser 
                è sicuro se appare il simbolo del lucchetto o se l'indirizzo inizia con https invece di http.</4>

            <4>I dati personali vengono trattati con il livello di protezione richiesto dalla legge per garantirne la sicurezza e impedirne l'alterazione, la perdita, il trattamento o l'accesso non autorizzato, tenendo conto dello stato dell'arte, 
            L'utente è consapevole e accetta che le misure di sicurezza di Internet non sono inespugnabili.

            <4>Advance Lighting, ogni qualvolta accede a dati personali, si impegna a:</4>   

            <4>Conservarli mediante misure di sicurezza di natura tecnica e organizzativa previste dalla legge che ne garantiscano la sicurezza, impedendone l'alterazione, la perdita, il trattamento o l'accesso non autorizzato,
                 in conformità con lo stato dell'arte in un determinato momento, la natura dei dati e i possibili rischi a cui sono esposti;</4> <4>Utilizzare i dati esclusivamente in base al loro utilizzo.

            <4>Utilizzare i dati esclusivamente per le finalità precedentemente definite;</4>  

            <4>Assicurarsi che i dati siano trattati solo dai lavoratori il cui intervento è necessario per l'erogazione del servizio e che sono tenuti al segreto e alla riservatezza.
             Nel caso in cui le informazioni possano essere comunicate a terzi, questi ultimi devono essere obbligati a mantenerle riservate in conformità alle disposizioni del presente documento.</4>  
              <3></3>
            <4>
            <2>6. ESERCIZIO DEI DIRITTI</2>
            <3></3>
            </4>

            <4>Conformemente alle disposizioni del LDPD e del GDPR, l'utente può esercitare i propri diritti di accesso, rettifica, cancellazione, limitazione, opposizione e portabilità in qualsiasi momento, mediante richiesta da parte di:</4>  
            <5>
            <6><7 href="mailto:info@gruporr.pt">info@gruporr.pt</7> </6>
            </5>

            <3></3>
            <4>Se l'utente desidera, in qualsiasi momento, smettere di far parte del database Advance, può esercitare questo diritto tramite questo contatto.</4>`,
      zh: `
         <1>隐私政策</1>
            <p>
            <2>1.信息和同意</2>
            <3></3>
            </p>

            <4>
            个人数据保护法（以下简称“LPDP”）和一般数据保护条例 
            （欧洲议会和理事会 2016 年 4 月 27 日第 (EU) 2016/679 号条例，以下简称“GDPR”） 
            确保在个人数据处理和此类数据的自由流动方面保护自然人。
            </4>
            <4>
            在法律术语中，“个人数据”是指与自然人相关的任何性质、无论其支持如何的任何信息，包括声音和图像。 
            已识别或可识别，这意味着保护不涵盖法人的数据。
            </4>

            <4>
            通过接受本隐私政策，用户对通过以下方式提供的个人数据表示知情、明确、自由和明确的同意： 
            来自网站 https://www.advancelighting.pt/ 的信息包含在 Advance Lighting 负责的文件中，其根据 LPDP 和 GDPR 条款进行的处理符合适当的技术和组织安全措施。
            </4>
            
            <4>
            Advance Lighting 维护着一个包含其客户记录的数据库。该数据库中存在的数据仅是他们在注册时提供的数据，
            由负责相应文件的实体 Advance Lighting 根据国家数据保护委员会批准的条款自动收集和处理。
            </4>

            <4>
            在任何情况下都不会要求提供有关哲学或政治信仰、党派或工会关系、宗教信仰、私生活和种族或民族血统的信息，以及与健康和性生活有关的数据，包括遗传数据。
            在任何情况下，我们都不会利用通过本网站提供给我们的个人数据进行以下任何活动：
            </4>
            <5>
                <6>未经数据主体事先同意，向其他人或其他实体提供；</6>
                <6>未经数据主体事先同意，转移到欧洲经济区 (EEA) 之外。</6>
            </5>
            <3></3>
            <4>
            <2>2.处理个人数据的目的</2>
            <3></3>
            </4>

            <4>我们通过此页面处理的个人数据将仅用于以下目的：</4>
            
            <5>
            (i) 购买和销售或服务提供合同的执行和管理；
                <6>(ii) 订单处理；</6>
                <6>(iii) 与客户沟通并澄清疑虑；</6>
                <6>(iv) 信息请求的处理；</6>
                <6>(v) 投诉处理、监管程序、诉讼前程序或在法律程序中行使权利；</6>
                <6>(vi) 统计分析活动；</6>
                <6>(vii) 验证、维护和开发统计系统和分析；</6>
                <6>(viii) 直接营销通讯（如果您同意为此目的处理您的个人数据）；</6>
                <6>(ix) 预防和打击欺诈；</6>
                <6>(x) 请求对购买的产品或服务发表评论；</6>
                <6>（十一）开展满意度调查。</6>
                <6>(xii) 管理和参与活动、竞赛和活动。</6>
            </5>
            
            <4>Advance 保证对客户提供的所有数据保密。尽管 Advance 以安全的方式收集和处理数据，防止数据丢失或被篡改、 
                但我们想告诉您，在开放网络上收集数据会使个人数据在没有安全条件的情况下流通，从而有可能被未经授权的第三方看到和使用。</4>

            <4>另一方面，用户同意获取与Advance Lighting签订的服务合同相关的信息，以便为合同服务提供附加服务。</4>

            <4>在收集个人数据时，除另有说明的领域外，用户可自愿提供个人数据，不因未作答复而降低相应服务的质量或数量（另有说明的除外）。
            除非另有说明）。但是，如果不回复被认为是强制性的数据，则将导致无法获得要求提供数据的服务。</4>

            <4>如果您不同意上述条件，Advance Lighting 将无法通过其网站与您签订合同。</4>
            
            <4>
            <2>3. 个人数据的传输</2>
            <3></3>
            </4>

            <4>为了实现本网站的目的，Advance Lighting 将把您的个人数据传输给其他实体，这些实体将出于以下目的处理这些数据：</4>

            <5>
                <6>付款管理和处理活动；</6>
                <6>提供签约服务。
                <6>管理和参与活动、竞赛和宣传活动。
            </5>

            <4>为了根据上述条款处理您的个人数据，Advance Lighting 将向以下实体转移您的个人数据：</4>

            <5>
                <6>保险机构；</6
                <6>与提供合同服务有关的第三方；</6>
                <6>付款管理和处理机构。
            </5>
            <3></3>
            <4>
            <2>4. 安全措施</2>
            <3></3>
            </4>
            
                    <4>Advance Lighting声明，已实施并将继续实施必要的技术和组织安全措施，以保证向其提供的个人数据的安全，防止其被篡改、丢失、处理和/或未经授权的访问。
             在考虑到当前的技术水平、所存储数据的性质以及所面临的风险的情况下，我们将采取必要的技术和组织安全措施，以确保向其提供的个人数据的安全，防止其被篡改、丢失、处理和/或未经授权的访问。

             <4>Advance Lighting保证对客户在注册和购买/订购产品或服务时提供的所有数据保密。数据的收集和处理在安全的环境中进行。
                数据是以安全的方式收集和处理的，以防止数据丢失或被篡改。所有数据均输入安全服务器（128 位 SSL），该服务器会对数据进行加密（将数据转换为代码）。用户可以通过浏览器 
                是否安全，如果出现挂锁符号，或者地址以 https 而不是 http 开头。

            <4>个人数据的处理符合法律要求的保护水平，以保证其安全性，并防止其更改、丢失、处理或未经授权的访问，同时考虑到技术水平、 
            用户了解并接受互联网安全措施并非坚不可摧。

            <4>Advance Lighting 在访问任何个人数据时，承诺：</4 > 

            <4>通过法律要求的技术和组织性质的安全措施来存储这些数据，以确保其安全性，从而防止更改、丢失、处理或未经授权的访问、
                 根据任何特定时间的技术水平、数据的性质和可能面临的风险；</4 > 

            <4>仅将数据用于之前定义的目的；</4 > 

            <4>确保只有提供服务所需的工作人员才能处理数据，而且他们必须履行保密义务。
             如果可能向第三方披露信息，他们必须按照本文件的规定履行保密义务。</4 > 
              <3></3>
            <4>
            <2>6.行使权利</2>
            <3></3>
            </4>

            <4>根据LDPD和GDPR的规定，用户可以通过以下方式提出请求，随时行使其访问、更正、删除、限制、反对和可移植的权利：</4>  
            <5>
            <6><7 href="mailto:info@gruporr.pt">info@gruporr.pt</7> </6>
            </5>

            <3></3>
            <4>如果用户随时希望停止成为 Advance 数据库的一部分，他们可以通过此联系人行使此权利。</4> `,
    },
  },
]